import Repository from './Repository'

const resource = '/twilio'
const resourcePhones = '/company-twilio-numbers'

export default {
  async setUp (param) {
    try {
      return await Repository.get(`${resource}/set-up`, param, { timeout: 30000 })
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getSetting() {
    try {
      return await Repository.get(`${resource}/settings`)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getConferenceBySid(data, reload = false) {
    try {
      return await Repository.get(`${resource}/conference`, data, {}, reload)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async updateSetting(data) {
    try {
      return await Repository.post(`${resource}/settings`, data)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getCurrentConferences() {
    try {
      return await Repository.get(`${resource}/get-conferences`)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async rejectTask(taskSid) {
    try {
      return await Repository.post(`${resource}/reject/${taskSid}`)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async joinConferenceMonitoring(data) {
    try {
      return await Repository.post(`${resource}/join-conference-monitoring`, data)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async enableWhisper(data) {
    try {
      return await Repository.put(`${resource}/set-on-whisper`, data)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async disableWhisper(data) {
    try {
      return await Repository.put(`${resource}/set-off-whisper`, data)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getTwilioPhone(twilioPhone) {
    try {
      return await Repository.get(`${resourcePhones}/${twilioPhone}`)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async getTwilioPhones() {
    try {
      return await Repository.get(`${resourcePhones}`)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async insertTwilioPhones(data) {
    try {
      return await Repository.post(`${resourcePhones}`, data)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async updateReservationStatus(status, reservationSid, taskSid) {
    try {
      return await Repository.post(`${resource}/reservation/${status}/${reservationSid}/${taskSid}`)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async updateExpressionWorkflow(isSilent = false) {
    try {
      return await Repository.post(`${resource}/update-expression-workflow`, {}, {}, {}, isSilent)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async updateConferenceInstruction(isSilent = false) {
    try {
      return await Repository.post(`${resource}/update-conference-instruction`, {}, {}, {}, isSilent)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  setErrors(e) {
    const errorCode = e.response ? e.response.status : 500
    return {
      status: false,
      errorCode: errorCode,
      data: e.response ? e.response.data : 'error',
      error: e
    }
  },
  catchError(e) {
    return e.response ? e.response.data : 'error'
  }
}
